import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ScaleIcon, ArrowLeftIcon } from 'lucide-react';
import { TermsAccordion } from '../components/policies/TermsAccordion';
export function Terms() {
  return <>
      <Helmet data-id="element-2251">
        <title data-id="element-2252">Terms & Conditions | Bright Pixxel Studios</title>
        <meta name="description" content="Our Terms & Conditions cover project scope, payments, intellectual property, approvals, change control, warranties, and liability." data-id="element-2253" />
      </Helmet>
      {/* Hero Section */}
      <section className="pt-16 md:pt-24 pb-12 bg-[#F9FAFB] dark:bg-[#121212]" data-id="element-2254">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2255">
          <div className="max-w-4xl mx-auto" data-id="element-2256">
            <Link to="/policies" className="inline-flex items-center text-[#0C1B26] hover:underline mb-6" data-id="element-2257">
              <ArrowLeftIcon size={16} className="mr-1" data-id="element-2258" />
              Back to Policies
            </Link>
            <div className="flex items-center mb-6" data-id="element-2259">
              <div className="w-12 h-12 rounded-full bg-[#0C1B26]/10 dark:bg-[#0C1B26]/20 flex items-center justify-center mr-4" data-id="element-2260">
                <ScaleIcon size={24} className="text-[#0C1B26]" data-id="element-2261" />
              </div>
              <motion.h1 initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 0.5
            }} className="text-3xl md:text-4xl font-bold" data-id="element-2262">
                Terms & Conditions
              </motion.h1>
            </div>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg text-gray-600 dark:text-gray-300 mb-4" data-id="element-2263">
              Last Updated: May 1, 2023
            </motion.p>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-gray-600 dark:text-gray-300" data-id="element-2264">
              These Terms & Conditions ("Terms") govern the relationship between
              Bright Pixxel Studios ("we", "us", "our") and clients ("you",
              "your") who engage our services. By using our services, you agree
              to be bound by these Terms.
            </motion.p>
          </div>
        </div>
      </section>
      {/* Policy Content */}
      <section className="py-12 bg-white dark:bg-[#1E1E1E]" data-id="element-2265">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2266">
          <div className="max-w-4xl mx-auto" data-id="element-2267">
            <TermsAccordion data-id="element-2268" />
          </div>
        </div>
      </section>
    </>;
}